import React from 'react';
import classnames from 'classnames';
import { Icon } from '../icon';
import { CommonInputProps } from '../types';
import { InputMessage } from '../input-message';

import styles from './checkbox.module.scss';

export type CheckboxProps = {
  value: React.InputHTMLAttributes<HTMLInputElement>['value'];
  label: string | JSX.Element;
} & Omit<CommonInputProps, 'label'> &
  Pick<React.InputHTMLAttributes<HTMLInputElement>, 'checked' | 'onChange' | 'autoFocus'>;

const baseClass = 'checkbox';

export const Checkbox = React.forwardRef<HTMLInputElement, CheckboxProps>(
  (
    { id, label, disabled, name, onChange, className, value, required, checked, message, isInvalid, autoFocus },
    ref
  ) => {
    const labelId = `${id}__label`;
    const messageId = `${id}__message`;
    const classes = classnames(
      styles.checkbox,
      {
        [styles[`${baseClass}--error`]]: isInvalid,
        [styles[`${baseClass}--text-label`]]: typeof label === 'string'
      },
      className
    );

    return (
      <div className={classes} data-testid="checkbox-component">
        <input
          id={id}
          type="checkbox"
          disabled={disabled}
          className={styles[`${baseClass}__input`]}
          checked={checked}
          name={name}
          value={value}
          onChange={onChange}
          aria-labelledby={labelId}
          ref={ref}
          required={required}
          aria-invalid={isInvalid}
          aria-describedby={messageId}
          autoFocus={autoFocus}
        />
        <label htmlFor={id} id={labelId} className={styles[`${baseClass}__label`]}>
          <div className={styles[`${baseClass}__check-mark--touch-area`]}>
            <div className={styles[`${baseClass}__check-mark`]}>
              <Icon className={styles[`${baseClass}__icon`]} name="successful-checkmark--small" aria-hidden />
            </div>
          </div>
          <div className={styles[`${baseClass}__label-text`]}>{label}</div>
        </label>
        {message && (
          <InputMessage
            isError={isInvalid}
            message={message}
            disabled={disabled}
            className={styles[`${baseClass}__input-message`]}
            id={messageId}
          />
        )}
      </div>
    );
  }
);

Checkbox.displayName = 'Checkbox';
